import React from 'react';
import { Heading } from '@uk-source-web/heading';
import { InfoCardsProps } from './InfoCardsContainer.types';
import SWUtilityCard from '../../Elements/SWUtilityCard/SWUtilityCard';
import { SimpleGrid } from '@uk-source-web/simple-grid';
import { InfoCardsWrapper } from './InfoCardsContainer.styles';

const InfoCardsContainer = ({ infoCards, title }: InfoCardsProps) => {
  return (
    <>
      <InfoCardsWrapper>
        {title && (
          <Heading level={3} weight={3}>
            {title}
          </Heading>
        )}
        <SimpleGrid
          layout={{ sm: [12], md: [6, 6], lg: [6, 6] }}
          spacing={5}
          verticalAlign={'stretch'}
          justify={'center'}
          id="grid-items"
        >
          {infoCards.map(card => (
            <SWUtilityCard {...card} />
          ))}
        </SimpleGrid>
      </InfoCardsWrapper>
    </>
  );
};

export default InfoCardsContainer;
